var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _ellipse, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStepIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 65,
    viewBox: "0 0 70 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M40.0562 0.702117C35.5521 1.85922 31.7772 4.50194 29.476 8.55664C27.583 11.8927 26.4762 15.7597 23.7725 18.5874C20.8922 21.5995 18.5551 23.1767 14.4822 23.6437C-0.369578 25.3474 0.222537 49.7869 14.1165 59.5145C28.0105 69.242 57.9926 67.9542 66.646 39.7801C75.2995 11.6061 62.6253 3.94524 52.2042 0.905474C48.4117 -0.201024 44.0446 -0.322486 40.0562 0.702117Z",
    fill: "#FFDCD4"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 9.5,
    width: 42,
    height: 49,
    rx: 4,
    fill: "#3A6EEC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 11.5,
    width: 38,
    height: 45,
    rx: 4,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 27,
    width: 23,
    height: 1,
    rx: 0.5,
    fill: "#081E54"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 32,
    width: 23,
    height: 1,
    rx: 0.5,
    fill: "#081E54"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 37,
    width: 23,
    height: 1,
    rx: 0.5,
    fill: "#081E54"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 42,
    width: 23,
    height: 1,
    rx: 0.5,
    fill: "#081E54"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 38,
    cy: 10.0469,
    rx: 10,
    ry: 10,
    fill: "#E12D2D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34 6.5L41.9991 14.4994",
    stroke: "white",
    strokeWidth: 1.40446,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0009 14.4994L42 6.5",
    stroke: "white",
    strokeWidth: 1.40446,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.51912 43.868C3.2054 43.5681 3.19446 43.0688 3.49599 42.7534L8.18533 37.8476C8.48629 37.5328 8.985 37.5206 9.29931 37.8211C9.61363 38.1216 9.62339 38.6197 9.32243 38.9346L4.63252 43.8409C4.33156 44.1558 3.83228 44.1685 3.51855 43.8686L3.51912 43.868Z",
    fill: "#FF8165"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25736 43.7604L3.36862 39.0873C3.0549 38.7874 3.04395 38.2881 3.34548 37.9726C3.64702 37.6572 4.14515 37.6456 4.45947 37.9461L9.34821 42.6192C9.66193 42.9191 9.67288 43.4184 9.37191 43.7333C9.07095 44.0481 8.57168 44.0609 8.25736 43.7604Z",
    fill: "#FF8165"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1586 30.5455C62.9494 30.3434 62.9427 30.0111 63.1437 29.8031L66.2729 26.5641C66.4739 26.3561 66.8062 26.3513 67.0154 26.5534C67.2246 26.7555 67.2313 27.0878 67.0303 27.2958L63.9011 30.5348C63.7001 30.7428 63.3677 30.7476 63.1586 30.5455Z",
    fill: "#FF8165"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3533 30.4961L63.0963 27.3495C62.8871 27.1474 62.8805 26.8151 63.0815 26.6071C63.2825 26.399 63.6148 26.3942 63.824 26.5963L67.081 29.7429C67.2902 29.9451 67.2968 30.2774 67.0959 30.4854C66.8949 30.6934 66.5625 30.6982 66.3533 30.4961Z",
    fill: "#FF8165"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepIcon2);
export default __webpack_public_path__ + "static/media/StepIcon2.7ad7d01282a74d8ea19d74dfecf1b7e6.svg";
export { ForwardRef as ReactComponent };